/**
 * ScrollToTop Component
 * 
 * Automatically scrolls to the top of the page when the route changes
 * This ensures users always start at the top when navigating to a new page
 */

import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}
